/* global angular */
(function (angular) {
    'use strict';

    /**
     * @ngdoc service
     * @name DocumentSourceUrlController
     *
     * @description
     * DocumentSourceUrlController is a base class for Controllers which use `documentSourceUrl` in src/assets/partials/app/layout.html to trigger single file download.
     * Inherited by 
     */
    angular.module('GorillaBoy.common')
    .factory('DocumentSourceUrlController', [
        '$rootScope',
        '$q',
        '$sce',
        '$log',
        'MessageManager',
        'MessageProvider',
        'DocumentService',
        DocumentSourceUrlController
    ]);

    function DocumentSourceUrlController($rootScope, $q, $sce, $log, MessageManager, MessageProvider, DocumentService) {
        var $scope = null;

        return {
            initScope : function(scopeVal) {
                $scope = scopeVal;
                $scope.$on("$destroy", function() {
                    $scope = null;
                });

                // common logic to preflight document download request
                $scope.updateDocumentSourceUrl = function(url, nonZeroSize) {
                    if (!url) {
                        return;
                    }
    
                    DocumentService.preflightDocumentDownload(url, nonZeroSize)
                    .then(function() {
                        $scope.documentSourceUrl = $sce.trustAsResourceUrl(url);
                    })
                    .error(function(data, status){
                        if (status === 403 && data.indexOf('Access Denied') >= 0) {
                            // KMS key revoked case
                            MessageManager.addErrorMessage(MessageProvider.documentDownloadFailKmsError(window.location.hostname));
                            $rootScope.metricServiceInstance.newCounterMetric(`DocumentSource.Error.${status}.KMS.VersionDownload`);
                            $log.error(`Failed to download document version due to KMS error: ${data}`);
                        } else {
                            MessageManager.addErrorMessage(MessageProvider.documentDownloadFail);
                            $rootScope.metricServiceInstance.newCounterMetric(`DocumentSource.Error.${status}.VersionDownload`);
                            $log.error(`Failed to download document version due to error ${status}: ${data}`);
                        }
                    });
                };
            }
        };
    }
}(angular));
